import Vue from "vue/dist/vue.esm";
import $ from 'jquery';
import 'jquery-ui/ui/widgets/draggable.js';

// TODO: popupDataをcomponentから明示的に指定する
var popup = Vue.extend({
  data: function() {
    return {
    }
  },
  methods: {
    close: function() {
      this.popupData.show = false;
    }
  },
  mounted: function() {
    $("#js-popup").draggable({
      handle: ".popup-container"
    });
  },
  template: `
    <transition name="popup">
      <div class="popup-wrapper" id="js-popup" :class="{'popup-position-top-left': popupData.posTopLeft}">
        <div class="popup-container">
          <button class="btn btn-base btn-compact pos-top-right" @click.prevent="close()">✕</button>
          <div :class="{ 'loading-circular-spinner': isLoading }">
            <div class="popup-header">
              <slot name="header"></slot>
            </div>
            <div class="popup-body">
              <div class="table-scrollable">
                <slot name="body">{{popupData.content}}</slot>
              </div>
            </div>
            <div class="popup-footer clearfix">
              <slot name="footer"></slot>
            </div>
          </div>
      </div>
    </div>
  </transition>
  `,
  computed: {
    isLoading: function () {
      return this.popupData.propsLoading;
    }
  }
});

export default {
  popup
}